import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconClock9OClock: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="clock-9-o-clock, time, 9-00"><path d="M12 6.75V12H7.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><circle cx="12" cy="12" r="9.25" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconClock9OClock;
